import React from 'react';
import { ExTextPanel } from './view/exTextPanel';

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === 'ExTextPanel', 
  itemElt: (item, cmsOption) => <ExTextPanel item={item} cmsOption={cmsOption} />
}